import React from 'react'

import { AlertModal, ConfirmModal, useModalContext } from '@fourthwall/components'

export type DisconnectErrorModalProps = {
  isEnabled: boolean
  onDisable: () => void
}

export const DisconnectErrorModal = ({ isEnabled, onDisable }: DisconnectErrorModalProps) => {
  const { close } = useModalContext()

  const title = 'You cannot disconnect Meta while orders are still processing'

  if (isEnabled) {
    return (
      <ConfirmModal
        title={title}
        text={
          <>
            Because there are Meta orders that have not yet been delivered, Meta does not allow you
            to disconnect the integration. You can disable sales though, so that no new orders can
            be placed.
          </>
        }
        confirmLabel="Disable Meta shop sales"
        onConfirm={onDisable}
        close={close}
      />
    )
  }

  return (
    <AlertModal
      title={title}
      size="small"
      text={
        <>
          You have disabled Meta Shop, so you will no longer receive additional orders, but you
          cannot disconnect the app until all existing orders are delivered.
        </>
      }
      close={close}
    />
  )
}
